// Base URL do vdplayer, compartilhada por transcriptService e vdplayerPositionSync.
// Sempre termina com '/'.
//
// Por que existe fallback em vez de só ler a env: `VUE_APP_VDPLAYER_URL` é uma
// variável NOVA desta feature e não acompanha todo build/ambiente. Sem fallback,
// `undefined` era concatenado na URL ("undefinedbroadcasts/offline-sessions"),
// virando request relativa → 404 → o catch engole → a fila de sessões offline
// envenena e o progresso do aluno some, junto com as transcrições. Falha silenciosa
// e cara de rastrear. O fallback deriva do ambiente pela URL da API do EAD, que já
// é commitada em todos os .env.

const STAGING_URL = 'https://vdplayer.st.voxeldigital.com.br/';
const PRODUCTION_URL = 'https://vdplayer.voxeldigital.com.br/v2/';

function resolveBaseUrl () {
  const explicit = process.env.VUE_APP_VDPLAYER_URL;
  if (explicit) return explicit.endsWith('/') ? explicit : `${explicit}/`;

  // Sem a env: deriva do ambiente. A API do EAD em staging é `api.st.*`.
  // Conservador — na dúvida aponta pra staging, nunca pra produção.
  const apiUrl = process.env.VUE_APP_EAD_API_URL || '';
  const isProduction = /^https?:\/\/api\.pagtrust\.com\.br/i.test(apiUrl);
  const derived = isProduction ? PRODUCTION_URL : STAGING_URL;

  console.warn(
    `[vdplayer] VUE_APP_VDPLAYER_URL ausente no build — usando fallback "${derived}". ` +
    'Defina a variável no .env do ambiente para evitar ambiguidade.'
  );
  return derived;
}

export const VDPLAYER_BASE_URL = resolveBaseUrl();
